'use client'

import React, { useEffect, useState } from 'react'
// import { Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
    changeShippingMethodValue,
    initializeCartInfo,
    changeCurrentStep,
} from '@/shared/store/slice/cartSlice'
import { Area } from '@/features/cart-page/Area/ui/Area'
import { ShippingMethods } from '@/features/cart-page/ShippingMethods/ui/ShippingMethods'
import { PaymentMethods } from '@/features/cart-page/PaymentMethods/ui/PaymentMethods'
import { ShippingAddress } from '@/features/cart-page/ShippingAddress/ui/ShippingAddress.jsx'
import { Confirm } from '@/features/cart-page/Confirm/ui/Confirm'

export const PlacingOrder = ({ cert, userInfo }) => {
    // const { currentStep, initializeIsLoading } = useSelector((state) => state.cartActions)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(initializeCartInfo())
        dispatch(changeShippingMethodValue(null))
        if (cert) {
            dispatch(changeCurrentStep(3))
        }
    }, [cert])

    return (
        <div className={'PlacingOrder'}>
            {!cert && <Area userInfo={userInfo} />}
            {!cert && <ShippingMethods userInfo={userInfo} />}
            <PaymentMethods cert={cert} userInfo={userInfo} />
            <ShippingAddress userInfo={userInfo} />
            <Confirm />
        </div>
    )
}
